import React from 'react';

const CartItemErrorState: React.FC = () => {
  return (
    <div className="bg-gray-900 rounded-2xl border border-red-500 p-6">
      <p className="text-red-400">Error loading event details</p>
    </div>
  );
};

export default CartItemErrorState;

